export const userRights = (data) => {
  console.log(data);
  return {
    type: "USERRIGHTS",
    payload: data,
  };
};
